import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Table } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import styles from './style.module.scss';
import CampaignRequestService from '../../services/campaign-request';
import BootstrapTable from 'react-bootstrap-table-next';
import Pagination from 'react-js-pagination';
import { Trans } from 'react-i18next';
import {parseDateBR} from "helpers/date";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faLink } from '@fortawesome/free-solid-svg-icons'

const CampaignsList = () => {

  const defaultFilters = { search: '', per_page: 10, page: 1, elite: '' };
  const [filters, setFilters] = useState(defaultFilters);
  const [reports, setReports] = useState({data:[]});
  const [info, setInfo] = useState({segment:[],client_type:[],status:[],bu:[],load:true});

  const [pageReturn, setPageReturn] = useState('./resales/show');
  const Data = [];
  let detailsArray = [];

  useEffect(() => {
    let campaigns = CampaignRequestService.getAll({ params: { ...filters } });
    campaigns
      .then(data => {
        
        setReports(data.data);
      });
  }, [filters]);

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  const handlePageChange = page => handleFilterChange({ page });

  const renderData = () => {
    Object.values(reports.data).forEach((campaign, k) => {
      Data.push({
        id: campaign.id,
        btn:btn(campaign.id),
        btn_edit:btn_edit(campaign.id),
        brands: campaign.manufacturer_name,
        dt_start: parseDateBR(new Date(campaign.start_at).toLocaleDateString()),
        dt_end: parseDateBR(new Date(campaign.end_at).toLocaleDateString()),
      });
    });
  }

  const columns = [
    {
      dataField: 'btn',
      text: '',
      headerStyle: {
        width: '4%'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'brands',
      text: 'Marca',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'dt_start',
      text: 'Data Inicio',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'dt_end',
      text: 'Data Final',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'btn_edit',
      text: '',
      headerStyle: {
        width: '4%'
      },
      style: {
        textAlign: 'center'
      }
    },
  ];

  function btn_edit(id) {
    var btn_id = "btn-edit-" + id;
    return (
    <Button variant="primary" className="font-12" type="button" id={btn_id} onClick={()=>{

      window.location.href = window.location.href+(window.location.href.substr(-1)=='/'?'':'/')+'show?id='+id;
    }}>
      Editar
    </Button>);
  }

  function btn(id) {
    id = "btn-" + id;
    return <FontAwesomeIcon icon={faAngleRight} id={id}/>
  }

  const btn_move = id => {
    var btn = document.getElementById("btn-" + id);
    if (!btn.className.baseVal.includes("fa-rotate-90")) {
      btn.className.baseVal = btn.className.baseVal+"fa-rotate-90";
    } else {
      btn.className.baseVal = btn.className.baseVal.replace('fa-rotate-90', '');
    }
  }

  renderData();
  
  const getDetails = rowId => {
    let retorno = [];
    Object.values(reports.data).forEach(info => {
      if(rowId == info.id){
        Object.values(info.companies).forEach(c=>{
          retorno.push({
             name:c.name
          })
        })
      }
    });
    return retorno;
  };

  const expandRow = {
    renderer: row => (
      <>
        {btn_move(row.id)}
        <Table>
          <tbody>
          {getDetails(row.id).map((d,k) => {
            return <tr key={k}><td>{d.name}</td></tr>
          })}
          </tbody>
        </Table>
        </>
    )
  };

  

  return (
    <>
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <Card.Body>
                <Row>
                  <Col xs={6} className="align-self-center">
                    <h4 className={styles.headerTitle}>
                      Campanhas
                    </h4>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <hr className={styles.line} />
                  </Col>
                </Row>
                <Row style={{display:'none'}}>
                  <Col xs={2}>
                    <Form.Group>
                      <Form.Label>Pesquisa:</Form.Label>
                      <Form.Control
                        as="input"
                        //value={filters.per_page}
                        onChange={e => handleFilterChange({ search: e.target.value })}
                      >
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={2}>
                    <Form.Group>
                      <Form.Label>Classificação:</Form.Label>
                      <Form.Control
                        as="select"
                        value={filters.elite}
                        onChange={e =>
                          handleFilterChange({ elite: e.target.value })
                        }
                      ><option value="">Todos</option>
                      <option value={0}>Não Elite</option>
                      <option value={1}>Elite</option>
                      <option value={2}>Elite Vip</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={2}>
                    <Form.Group>
                      <Form.Label>BU:</Form.Label>
                      <Form.Control
                        as="select"
                        value={filters.bu}
                        onChange={e =>
                          handleFilterChange({ bu: e.target.value })
                        }
                      >
                      <option value="">Todos</option>
                      {info.bu.map((bu, key)=>{
                        return(
                        <option value={bu.id} key={key}>{bu.name}</option>
                        );
                      })}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={2}>
                    <Form.Group>
                      <Form.Label>Tipo de cliente:</Form.Label>
                      <Form.Control
                        as="select"
                        value={filters.client_type}
                        onChange={e =>
                          handleFilterChange({ client_type: e.target.value })
                        }
                      ><option value="">Todos</option>
                      {Object.values(info.client_type).map((v,key)=>{
                        return (<option value={v.id} key={key}>{v.name}</option>)
                      })}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={2}>
                    <Form.Group>
                      <Form.Label>Segmento:</Form.Label>
                      <Form.Control
                        as="select"
                        value={filters.segment}
                        onChange={e =>
                          handleFilterChange({ segment: e.target.value })
                        }
                      ><option value="">Todos</option>
                      {Object.values(info.segment).map((v,key)=>{
                        return (<option value={v.id} key={key}>{v.name}</option>)
                      })}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={2}>
                    <Form.Group>
                      <Form.Label>Status:</Form.Label>
                      <Form.Control
                        as="select"
                        value={filters.status}
                        onChange={e =>
                          handleFilterChange({ status: e.target.value })
                        }
                      >
                        <option value="">Todos</option>
                        {Object.values(info.status).map((v,key)=>{
                        return (<option value={v.id} key={key}>{v.name}</option>)
                      })}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                
                <Row>
                <Col>
                    <Form.Group>
                      <Button variant="dark"
                        onClick={()=>{
                          window.location.href = window.location.href+(window.location.href.substr(-1)=='/'?'':'/')+'show';
                        }}>
                        Criar Campanha
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>
                
                <Row>
                  <Col xs={3}>
                    <Form.Group>
                      <Form.Label>Registros por página:</Form.Label>
                      <Form.Control
                        as="select"
                        value={filters.per_page}
                        onChange={e =>
                          handleFilterChange({ per_page: e.target.value })
                        }
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <BootstrapTable
                  id="table"
                  className="font-10"
                  keyField="id"
                  data={Data}
                  columns={columns}
                  expandRow={expandRow}
                />
                <Row>
                  <Col>
                    <Trans i18nKey="label:interpolateShowingRecords">
                      Showing {{ from: reports.from || '0' }} to{' '}
                      {{ to: reports.to || '0' }} from {{ total: reports.total }}{' '}
                      records
                    </Trans>
                  </Col>
                  <Col className="d-flex justify-content-end">
                    <Pagination
                      activePage={reports.current_page}
                      itemsCountPerPage={reports.per_page}
                      totalItemsCount={reports.total}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                      prevPageText="‹"
                      nextPageText="›"
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default MasterPage(CampaignsList);